<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllStockBalance('printStockBalance')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockBalance()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Name"
                type="text"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                label="Cateogry"
                v-model="queryParams.categoryId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                label="Brand"
                v-model="queryParams.brandId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm6>
              <v-autocomplete
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseIds"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
                multiple
                @change="setBin()"
                :readonly="checkUserWarehouse().length > 0 ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm6>
              <v-autocomplete
                :items="bins"
                label="Bin"
                v-model="queryParams.binId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productGroupList"
                label="Product Group"
                v-model="queryParams.productGroupId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="balanceTypeList"
                label="Balance"
                v-model="queryParams.balanceType"
                item-text="text"
                item-value="value"
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="stockLevelList"
                label="Stock Level"
                v-model="queryParams.stockLevelType"
                item-text="text"
                item-value="value"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text" @click="show = !show">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Qty:</span>
              <v-chip>
                <span>{{ totalQty | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.binName }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.categoryName }}</td>
              <td>{{ props.item.productGroupName }}</td>
              <td>{{ props.item.brandName }}</td>
              <td>{{ props.item.qtyStr }}</td>
              <td style="text-align: right">
                {{ props.item.qty | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printStockBalance"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock Balance Report</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">Bin</th>
              <th style="border: 1px solid black; text-align: center">
                Product Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody v-for="(stockPage, index) in allStockList" :key="index">
            <tr v-for="(item, i) in stockPage.stockList" :key="i">
              <td
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-if="i == 0"
              >
                {{ stockPage.warehouseName }}
              </td>
              <td
                v-else
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              ></td>
              <td
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-if="i == 0"
              >
                {{ stockPage.binName }}
              </td>
              <td
                v-else
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qtyStr }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <summary report> -->
  </v-container>
</template>

<script>
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { warehouseService } from "../../services/warehouse-service";
import { productGroupService } from "../../services/product-group-service";
import { commonService } from "../../services/common-service";

export default {
  name: "StockBalanceSummaryList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    printAllButtonLoading: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Stock Balance Summary Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Warehouse", align: "left", value: "w.name" },
      { text: "Bin", value: "b.name" },
      { text: "Product Name", value: "p.name" },
      { text: "Product Code", value: "p.code" },
      { text: "Category", value: "c.name" },
      { text: "Product Group", value: "pg.name" },
      { text: "Brand", value: "br.name" },
      { text: "Qty", value: "temp.qty", sortable: false },
      { text: "Basic Qty", sortable: false },
    ],
    balanceTypeList: [
      { text: "ALL", value: "" },
      { text: "With Balance", value: "WITHBALANCE" },
      { text: "Without Balance", value: "WITHOUTBALANCE" },
    ],
    stockLevelList: [
      { text: "--All--", value: "" },
      { text: "MAX QTY", value: "MAX_QTY" },
      { text: "MIN QTY", value: "MIN_QTY" },
      { text: "REORDER QTY", value: "REORDER_QTY" },
    ],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "w.name",
      totalItems: 0,
    },
    queryParams: {
      productCode: "",
      productName: "",
      categoryId: "",
      brandId: "",
      warehouseIds: [],
      productGroupId: "",
      binId: "",
      balanceType: "",
      stockLevelType: "",
      binIds: [],
    },
    clonequeryParams: new Object(),
    rowsPerPageItems: [25, 50, 100],
    stockList: [],
    allStockList: [],
    categoryList: [],
    brandList: [],
    warehouseList: [],
    productGroupList: [],
    bins: [],
    totalRows: 0,
    totalQty: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.warehouseIds = this.checkUserWarehouse();
    if (
      this.user.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "SALE_MANAGER"
    ) {
      this.bins = this.user.selectedBinList;
      this.queryParams.binIds = [];
      this.user.selectedBinList.forEach((v) =>
        this.queryParams.binIds.push(v.id)
      );
    }
    this.clonequeryParams = Object.assign({}, this.queryParams);
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.productName) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.binId) {
      this.queryParams.binId = this.$route.query.binId;
    }
    if (this.$route.query.productGroupId) {
      this.queryParams.productGroupId = this.$route.query.productGroupId;
    }
    if (this.$route.query.balanceType) {
      this.queryParams.balanceType = this.$route.query.balanceType;
    }
    if (this.$route.query.stockLevelType) {
      this.queryParams.stockLevelType = this.$route.query.stockLevelType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getCategoryList();
    this.getBrandList();
    this.getProductGroupList();
  },
  methods: {
    checkUserWarehouse() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.warehouseId ? [this.user.warehouseId] : [];
      } else if (this.user.roleName == "SALE_MANAGER") {
        return [this.user.shop.warehouseId];
      }
      return [];
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-balance-summary",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getStockList();
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          if (
            this.checkUserWarehouse().length > 0 &&
            this.user.roleName != "WAREHOUSE_STAFF" &&
            this.user.roleName != "SALE_MANAGER" &&
            this.user.warehouseId
          ) {
            this.setBin();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBrandList() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductGroupList() {
      productGroupService
        .getAllProductGroup()
        .then((res) => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStockList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getStockBalanceSummaryList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockList = res.data.stockList;
            this.totalQty = res.data.totalQty;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAllStockBalance(divName) {
      this.printAllButtonLoading = true;
      stockService
        .getStockBalanceSummaryPrint(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allStockList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },

    getWarehouseDetail(id) {
      warehouseService.getWarehouseDetail(id).then((res) => {
        this.binList = res.data.binList;
      });
    },

    exportAllStockBalance() {
      this.printAllButtonLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .exportStockBalanceSummaryReportExcel(
          this.clonequeryParams,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    setBin() {
      this.bins = [];
      this.queryParams.binId = "";
      for (var i = 0; i < this.queryParams.warehouseIds.length; i++) {
        let warehouse = commonService.search(
          "id",
          parseInt(this.queryParams.warehouseIds[i]),
          this.warehouseList
        );
        if (warehouse.binList) {
          warehouse.binList.forEach((element) => {
            this.bins.push(element);
          });
        }
      }
    },
  },
};
</script>
